import { render } from "./ComparisonStores.vue?vue&type=template&id=4cda7fc5&scoped=true"
import script from "./ComparisonStores.vue?vue&type=script&lang=js"
export * from "./ComparisonStores.vue?vue&type=script&lang=js"

import "./ComparisonStores.vue?vue&type=style&index=0&id=4cda7fc5&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cda7fc5"]])

export default __exports__